import i18next from 'i18next';
import common from '../common';

export default class SelectTooltip extends PIXI.Container {
	constructor() {
		super();

		this._buttons = [];
		this._buttonPositions = [ // in order. first we want left, then right, then up and then down buttons.
			new PIXI.Point(-85, 0),
			new PIXI.Point(85, 0),
			new PIXI.Point(0, -75),
			new PIXI.Point(0, 75),
		];

		this._contextualButtons = [];

		this._defendButton = null;
		this._infoButton = null;
		this._developButton = null;
		this._repeatButton = null;
		this._demolishButton = null;
		this._upgradeButton = null;
		this._overlay = null;

		this.signals = {
			defendClick: new P3.utils.MiniSignal(),
			infoClick: new P3.utils.MiniSignal(),
			developClick: new P3.utils.MiniSignal(),
			repeatClick: new P3.utils.MiniSignal(),
			demolishClick: new P3.utils.MiniSignal(),
			upgradeClick: new P3.utils.MiniSignal(),
		};

		/*
			0 : Defend
			1 : Demolish
			2 : Info
			3 : Develop
			4 : Upgrade
			5 : Repeat
		*/

		this.init();
	}

	init() {
		this._overlay = new PIXI.Sprite(P3.assets.texture('selected_tile'));
		this._overlay.scale.set(0.5);
		this._overlay.position.set(0, 4);
		this.addChild(this._overlay);

		this._defendButton = this.createContextualButtons('icon_contextual_defend', 0);
		this._defendButton.signals.click.add(() => {
			this.signals.defendClick.dispatch(this);
		}, this);
		this._defendButton.position.set(this._buttonPositions[0].x, 0);
		this._defendButton.accessibleTitle = i18next.t('accessibility.button.defence');
		this.addChild(this._defendButton);
		this._buttons.push(this._defendButton);

		this._demolishButton = this.createContextualButtons('icon_contextual_demolish', 0);
		this._demolishButton.signals.click.add(() => {
			this.signals.demolishClick.dispatch(this);
		}, this);
		this._demolishButton.position.set(this._buttonPositions[0].x, 0);
		this._demolishButton.visible = false;
		this._demolishButton.accessibleTitle = i18next.t('accessibility.button.demolish');
		this.addChild(this._demolishButton);
		this._buttons.push(this._demolishButton);

		this._infoButton = this.createContextualButtons('icon_contextual_info', 2);
		this._infoButton.signals.click.add(() => {
			this.signals.infoClick.dispatch(this);
		}, this);
		this._infoButton.position.set(0, this._buttonPositions[2].y);
		this._infoButton.accessibleTitle = i18next.t('accessibility.button.tileInfo');
		this.addChild(this._infoButton);
		this._buttons.push(this._infoButton);

		this._developButton = this.createContextualButtons('icon_contextual_develop', 1);
		this._developButton.signals.click.add(() => {
			this.signals.developClick.dispatch(this);
		}, this);
		this._developButton.position.set(this._buttonPositions[1].x, 0);
		this._developButton.accessibleTitle = i18next.t('accessibility.button.building');
		this.addChild(this._developButton);
		this._buttons.push(this._developButton);

		this._upgradeButton = this.createContextualButtons('icon_contextual_upgrade', 1);
		this._upgradeButton.signals.click.add(() => {
			this.signals.upgradeClick.dispatch(this);
		}, this);
		this._upgradeButton.position.set(this._buttonPositions[1].x, 0);
		this._upgradeButton.accessibleTitle = i18next.t('accessibility.button.upgrade');
		this.addChild(this._upgradeButton);
		this._buttons.push(this._upgradeButton);

		this._repeatButton = this.createContextualButtons('icon_contextual_repeat', 3);
		this._repeatButton.signals.click.add(() => {
			this.signals.repeatClick.dispatch(this);
		}, this);
		this._repeatButton.position.set(0, this._buttonPositions[3].y);
		this._repeatButton.accessibleTitle = i18next.t('accessibility.button.repeat');
		this.addChild(this._repeatButton);
		this._buttons.push(this._repeatButton);
	}

	createContextualButtons(icon, direction) {
		const arrowPositions = [
			new PIXI.Point(25, 0),
			new PIXI.Point(-25, 0),
			new PIXI.Point(0, 25),
			new PIXI.Point(0, -25),
		];

		const states = new P3.ButtonStates();

		states.normal = P3.assets.texture('btn_contextual_out');
		states.icon = P3.assets.texture(icon);

		const button = common.buttonFactory.createButton(states);
		const arrow = new PIXI.Sprite(P3.assets.texture('btn_contextual_arrow'));

		arrow.anchor.set(0.5);
		arrow.position.set(arrowPositions[direction].x, arrowPositions[direction].y);
		button.addChildAt(arrow, 0);

		return button;
	}

	destroy() {
		// clean up goes here
		super.destroy();
	}

	/**
     * Sets buttons visible.
     * @param tile      {IsoTile}   The tile to select
     * @param buttons   {Array}     The buttons to show, in order
     */
	setVisible(tile, buttons = [2]) {
		this.setInvisible();

		for (let i = 0; i < buttons.length; i++) {
			this._buttons[buttons[i]].visible = true;
		}

		tile && tile.addChildAt(this._overlay, tile.getChildIndex(tile.structureSprite) - 1);
	}

	setInvisible() {
		this._overlay.parent && this._overlay.parent.removeChild(this._overlay);

		this._defendButton.visible = false;
		this._infoButton.visible = false;
		this._developButton.visible = false;
		this._repeatButton.visible = false;
		this._demolishButton.visible = false;
		this._upgradeButton.visible = false;
	}

	get defendButton() {
		return this._defendButton;
	}

	get infoButton() {
		return this._infoButton;
	}

	get developButton() {
		return this._developButton;
	}

	get repeatButton() {
		return this._repeatButton;
	}
}
